import {ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {Unidad} from '../../../../_models/unidad';
import {EstudioConexionesService} from '../_services/estudio-conexiones.service';
import {MapaCurricularService} from '../_services/mapa-curricular.service';
import {EstudioService} from '../../estudio.service';
import {MatSnackBar} from '@angular/material/snack-bar';
import {CustomAlertService} from '../../../../_components/custom-alert/custom-alert.service';
import {ComentariosService} from '../../../../_components/glm-comentarios/comentarios.service';
import {ThrobberService} from '../../../../_services/throbber.service';
import {Subscription} from 'rxjs';
import {GLMLanguageService} from '../../../../_services/glm-language.service';
import {MapaCurricularFiltrosService} from '../_services/mapa-curricular-filtros.service';

@Component({
  selector: 'unidad-mapa',
  standalone: false,
  templateUrl: 'mapa-curricular-unidad.component.html',
  styleUrls: ['./mapa-curricular-unidad.component.scss']
})

export class MapaCurricularUnidadComponent implements OnInit {

  @Input() unidad: Unidad;

  @Output()
  onEdit = new EventEmitter();

  private conexionesActivas = [];
  public conexiones = {
    status: {up: false, same: false, down: false},
    active: false,
    selfColor: '',
    activeColor: ''
  };
  private isEmisorConexion = false;
  private maskOn = false;
  public visibilidad: boolean = true;

  conexionesPreFinalizar: any = [];
  emisorClearSub = new Subscription();
  filtrosSub = new Subscription();

  public visibility = {
    ambitos: false,
    areas: false,
    cursos: false,
    fullHtml: false,
    tags: false
  };

  constructor(private snackBarRef: MatSnackBar,
              private conexionesService: EstudioConexionesService,
              private mapaCurricularService: MapaCurricularService,
              private estudioService: EstudioService,
              private customAlertService: CustomAlertService,
              private comentariosService: ComentariosService,
              private throbberService: ThrobberService,
              private filtrosService: MapaCurricularFiltrosService) {
  }

  ngOnInit() {
    this.filtrosSub = this.filtrosService.getFiltrosObservable().subscribe(filtro => {
      if (filtro.hasOwnProperty('detalles')) {
        this.setDetailVisibility(filtro['detalles']);
      }
      if (filtro.hasOwnProperty('filtros')) {
        this.unidad.show = this.checkFiltros(filtro.filtros);
      }
    });

    this.emisorClearSub = this.conexionesService.emisorClearAction$.subscribe(() => {
      this.isEmisorConexion = false;
      this.unidad.conexiones.status.down = false;
      this.unidad.conexiones.status.same = false;
      this.unidad.conexiones.status.up = false;
      this.unidad.conexiones.active = false;
      this.unidad.conexiones.selfColor = '';
      this.unidad.conexiones.activeColor = '';
    });

    this.conexionesService.getConexionesObservable().subscribe(evtConexion => {
      if (evtConexion.tipo == 'mostrarConexiones' && evtConexion.objeto.categoria == 'unidad') {
        if (evtConexion.objeto.on) {
          if (evtConexion.objeto.lista.indexOf(this.unidad.id) > -1 &&
            this.conexionesActivas.filter(el => el.codigo == evtConexion.objeto.codigo).length == 0) {
            this.conexionesActivas.push({
              color: evtConexion.objeto.color,
              codigo: evtConexion.objeto.codigo
            });
          }
        } else {
          this.conexionesActivas = this.conexionesActivas.filter((el) => el.codigo != evtConexion.objeto.codigo);
        }
      } else if (evtConexion.tipo == 'habilitarConexiones') {
        if (evtConexion.objeto.id == this.unidad.id) {
          this.isEmisorConexion = evtConexion.objeto.estado;
        } else {
          this.maskOn = evtConexion.objeto.estado;
        }
      } else if (evtConexion.tipo == 'estadoConexion' && this.unidad.id == evtConexion.objeto.idOrigen) {
        let coleccion,
          id;

        if (this.unidad.id == evtConexion.objeto.idOrigen) {
          coleccion = 'metas';
          id = evtConexion.objeto.idDestino;

        }
        if (evtConexion.objeto.estado) {
          // this.unidad[coleccion].push(id);
          this.conexionesPreFinalizar.push(id);
        } else {
          let indice = this.conexionesPreFinalizar.indexOf(id);
          // let indice = this.unidad[coleccion].indexOf(id);
          if (indice > -1) {
            // this.unidad[coleccion].splice(indice, 1);
            this.conexionesPreFinalizar.splice(indice, 1);
          }
        }
      } else if (evtConexion.tipo == 'limpiarConexiones') {
        this.conexiones.status.up = false;
        // this.conexiones.status.down = false;
        // this.conexiones.status.same = false;
        this.conexiones.active = false;
        this.conexiones.activeColor = '';
        this.conexionesActivas = [];
      } else if (evtConexion.tipo == 'visibilidadSoloConectadas') {
        if (evtConexion.estado) {
          if (this.conexiones.active || this.conexionesActivas.length > 0) {
            this.visibilidad = true;
          } else {
            this.visibilidad = false;
          }
        } else {
          this.visibilidad = true;
        }
      }
    });

    this.estudioService.getEstudioServiceObservable().subscribe((data) => {
      if (data.tipo == 'actualizar-unidad' && data.unidad.id == this.unidad.id) {
        let metas = Object.assign([], this.unidad.metas);
        this.unidad = data.unidad;
        this.unidad.metas = metas;
      }
    });
  }

  setDetailVisibility(detalles) {
    for (const prop in this.visibility) {
      if (this.visibility.hasOwnProperty(prop)) {
        if (detalles.indexOf(prop) > -1) {
          this.visibility[prop] = true;
        } else {
          this.visibility[prop] = false;
        }
      }
    }
  }

  checkDescripcion(descripcion) {
    let isVisible = this.unidad.show,
      descripcionCheck = descripcion.toLowerCase();

    if (descripcionCheck.length > 0 &&
      (this.unidad.nombre != null && this.unidad.nombre.toLowerCase().indexOf(descripcionCheck) > -1)) {
      isVisible = true;
    } else {
      if (descripcionCheck.length == 0) {
        isVisible = true;
      } else {
        isVisible = false;
      }
    }

    return isVisible;
  }

  checkFiltros(filtros) {
    let isVisible = false,
      filtraDescripcion = this.checkDescripcion(filtros['descripcion']),
      filtraAreas = this.checkColeccionFiltro(filtros['areas'], 'materias'),
      filtraCursos = this.checkColeccionFiltro(filtros['cursos'], 'cursos');

    isVisible = filtraDescripcion && (filtraAreas && filtraCursos);

    return isVisible;
  }

  checkColeccionFiltro(coleccionFiltro, nombreColeccionUnidad) {
    let isVisible = this.unidad.show,
      checker = [];
    if (coleccionFiltro.length > 0) {
      coleccionFiltro.map(id => {
        let temp = this.unidad[nombreColeccionUnidad].filter(el => el.id == id);
        if (temp.length == 1) {
          checker.push(temp[0]);
        }
      });
    }

    if (checker.length > 0 || coleccionFiltro.length == 0) {
      isVisible = isVisible || true;
    } else {
      isVisible = false;
    }
    return isVisible;
  }

  mostrarConexiones(dir) {
    this.conexionesService.showConexiones('up', this.unidad);
  }

  conectarCon() {
    this.conexionesPreFinalizar = Object.assign([], this.unidad.metas);
    this.isEmisorConexion = !this.isEmisorConexion;
    this.conexionesService.habilitarConexiones(this.unidad, this.isEmisorConexion);
  }

  finalizarConexion() {
    this.unidad.metas = this.conexionesPreFinalizar;
    this.isEmisorConexion = !this.isEmisorConexion;
    this.conexionesService.habilitarConexiones(this.unidad, this.isEmisorConexion);
  }

  editar(id) {
    this.throbberService.setThrobberState(true);
    const sub = this.estudioService.getUnidad(id).subscribe(res => {
        this.throbberService.setThrobberState(false);
        this.onEdit.emit(res);
      }, err => {
      },
      () => {
        sub.unsubscribe();
      });
  }

  estadoFavorita() {
    let modelo = {
      idOrigen: this.unidad.id,
      estado: !this.unidad.isFavorito
    };
    this.unidad.isFavorito = modelo.estado;
    this.estudioService.setUnidadFavorita(modelo).subscribe(res => {
      this.snackBarRef.open(
        `La unidad se ha ${modelo.estado ? 'marcado' : 'desmarcado'} como favorita.`,
        null,
        {duration: 2500}
      );
    }, err => {
      this.customAlertService.setCustomMessage({
        tipo: 'error',
        texto: `No ha sido posible ${modelo.estado ? 'marcar' : 'desmarcar'} la unidad como favorita. <br> ${err.error} <br> Código de error: ${err.statusText}`
      });
      this.unidad.isFavorito = !modelo.estado;
    });
  }

  estadoNotificaciones() {
    const modelo = {targetID: this.unidad.id, estado: !this.unidad.isNotificar, tipo: 'unidad'};
    this.unidad.isNotificar = modelo.estado;
    this.comentariosService.setEstadoSuscripcion(modelo).subscribe(res => {
      this.snackBarRef.open(
        `Las notificaciones han sido ${modelo.estado ? 'activadas' : 'desactivadas'} para la unidad.`,
        null,
        {duration: 2500}
      );
    }, err => {
      this.customAlertService.setCustomMessage({
        tipo: 'error',
        texto: `No ha sido posible ${modelo.estado ? 'activar' : 'desactivar'} las notificaciones para la unidad. <br> ${err.error} <br> Código de error: ${err.statusText}`
      });
      this.unidad.isNotificar = !modelo.estado;
    });
  }
}
